import * as React from 'react';
import { ImageField, ReferenceField, Show, ShowProps, SimpleShowLayout, TextField, UrlField } from 'react-admin';
import { TranslateField } from '../components/TranslateField';

export const RecipeShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show {...props}>
			<SimpleShowLayout>
				<TextField source="id" label="#"/>
				<ImageField source="imageUrl" label="IMAGE"/>
				<TextField source="title" label="TITLE"/>
				{/*<NumberField source="carbs" label="CARBS"/>*/}
				{/*<NumberField source="proteins" label="PROTEINS"/>*/}
				<TextField source="description" label="DESCRIPTION"/>
				<ReferenceField source="categoryId" reference="recipe-categories" label="CATEGORY">
					<TextField source="name"/>
				</ReferenceField>
				<UrlField source="videoUrl" label="YOUTUBE_LINK"/>
				<UrlField source="externalUrl" label="EXTERNAL_LINK"/>
				<TranslateField source="language" label="LANGUAGE"/>
			</SimpleShowLayout>
		</Show>
	);
};
